/*
|---------------------------------------------------------------------
| Board Vuex Mutations
|---------------------------------------------------------------------
|
| Synchronous operations for board store
|
*/
import Vue from 'vue'

export default {

    /* ------------------------- SET DATA STASTES/CARDS ------------------------- */
    setAllData: (state, { cards, states }) => {
        state.cards = cards
        state.states = states
    },
    /* ----------------------------- MUTATIONS CARDS ---------------------------- */
    addCard: (state, card) => {
        state.cards.push({
            // id: '_' + Math.random().toString(36).substr(2, 9),
            ...card
        })
    },

    updateCardsOrder: (state, cards) => {
        state.cards = cards
    },

    updateCard: (state, card) => {
        const cardIdx = state.cards.find((t) => t.id === card.id)
        Object.assign(cardIdx, card)
    },

    deleteCard: (state, card) => {
        const cardIdx = state.cards.findIndex((t) => t.id === card.id)
        if (cardIdx !== -1) state.cards.splice(cardIdx, 1)
    },

    // Aplica en vivo el payload de tickets.reserva.actualizada (websocket) a
    // la card correspondiente, sin refetch-ear el listado completo. No-op si
    // el ticket no está cargado en este momento (filtro/paginación/no visible).
    actualizarReservaTicket: (state, { ticket_id, reservado, reservado_por }) => {
        if (!state.cards) return
        // Comparación no estricta: ticket_id/reservado_por.id llegan numéricos
        // desde el WebSocket, y los ids en state.cards/state.users pueden llegar
        // como string desde la API (mismo motivo del == en TicketDetailPage.vue).
        const card = state.cards.find((c) => c.id == ticket_id)
        if (!card) return

        if (!reservado || !reservado_por) {
            Vue.set(card, 'reserva', null)
            return
        }

        // Enriquecer con el color del agente si ya tenemos su ficha cargada
        // (state.users) — el evento no trae color, y sin esto la card cae al
        // color por defecto hasta el próximo refetch completo.
        const userInfo = state.users?.find((u) => u.id == reservado_por.id)
        Vue.set(card, 'reserva', {
            usuario: { id: reservado_por.id, nombre: reservado_por.nombre, color: userInfo?.color },
            // created_at no viene en el evento y, al reasignar, el backend no
            // lo actualiza (sólo updated_at) — no lo aproximamos para no
            // mostrar una fecha incorrecta; se corrige en el próximo refetch.
            created_at: null,
        })
    },

    /* ---------------------------- MUTATIONS COLUMNS --------------------------- */

    addColumn: (state, _state) => {
        state.states.splice(state.states.length - 1, 0, _state);
    },

    deleteColumn: (state, _state) => {
        state.states.splice(_state, 1)
    },

    updateColumns: (state, states) => {
        state.states = states
    },


    /* ---------------------------------- USERS MUTATIONS --------------------------------- */

    setUsers: (state, users) => {
        state.users = users
    },

    /* --------------------------------- CLIENTS -------------------------------- */

    setClients: (state, clients) => {
        state.clients = clients
    },

}
